import { render, staticRenderFns } from "./TaStartElement.vue?vue&type=template&id=50bb02b7&scoped=true&"
import script from "./TaStartElement.vue?vue&type=script&lang=js&"
export * from "./TaStartElement.vue?vue&type=script&lang=js&"
import style0 from "./TaStartElement.vue?vue&type=style&index=0&id=50bb02b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb02b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
